import { computed, ref } from 'vue'

import {
  FilePrivacy,
  UserPermission,
  useUpdateFilePrivacyMutation,
} from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { useUserStore } from '@/shared/stores/user'
import { openModal, Modals } from '@/shared/dialogs/modals'

export const privacyOptions = [
  { label: 'Public', value: FilePrivacy.Public },
  { label: 'Private', value: FilePrivacy.Private },
]

export function useUpdateFilePrivacy(ids: string[], close: () => void) {
  const { mutate: updateFilePrivacy, loading } = useUpdateFilePrivacyMutation()

  const userStore = useUserStore()
  const toastStore = useToastStore()

  const isBasic = computed(
    () => !userStore.user?.permissions.includes(UserPermission.Pro)
  )

  const visibility = ref()

  const save = async () => {
    try {
      const response = await updateFilePrivacy({
        fileIds: ids,
        isPrivate: visibility.value === FilePrivacy.Private,
      })

      if (response?.data?.updateFilePrivacy.asyncProcess) {
        openModal(Modals.Success, {
          props: {
            title: 'Bulk change successful',
            html: 'Note: In some cases, it may take several minutes to process your request.',
          },
        })
      } else {
        close()

        toastStore.showToast({
          type: ToastType.Success,
          content: 'Successfully updated file privacy settings',
        })
      }
    } catch {
      toastStore.showToast({
        type: ToastType.Error,
        content: 'Could not update privacy settings',
      })
    }
  }

  return { isBasic, visibility, loading, save }
}
